import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { aichat, search } from 'src/app/shared/constants';
import { catchError, map } from 'rxjs/operators';
import { UikitService } from './uikit.service';
import { environment } from 'src/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient, private uikitService: UikitService, public storageService:StorageService) { }

  // this service call response for search text content details.
  getData(key, skip, take, type?): Observable<any> {
    let params: HttpParams = new HttpParams()
      .set('keyword', key)
      .set('skip', skip)
      .set('take', take)
      .set('facelift', '1')
      .set('version','v1');
    if(type){
      params = params.append('ai_chat', 1);
      params = params.append('chat_id', this.storageService.getSessionStore('chat_u_id'));
    }
    const endpoint = type ? aichat : search;
    const searchApiURL = environment.apiEndpoint + environment.version + endpoint 
    return this.http.get(searchApiURL, { params }).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

}
